import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { ToastrModule } from 'ngx-toastr';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { NgUploaderModule } from 'ngx-uploader';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { AppTranslationModule } from './app.translation.module';
import { DataTableModule } from 'angular2-datatable';
import { DateTimePickerModule } from 'ng-pick-datetime';
import { AmChartsModule } from "@amcharts/amcharts3-angular";
/*
* Platform and Environment providers/directives/pipes
*/
import { routing } from './app.routing';

// App is our top level component
import { App } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { NgaModule } from './theme/nga.module';
import { PagesModule } from './pages/pages.module';
import { ConfirmComponent } from './modals';
import { ConfirmMemberComponent } from './modals';
import { SurveyErrorActivateComponent } from './modals';
import { GroupMembersComponent } from './modals';
import { TaskPerformersComponent } from './modals';
import { TaskGroupsComponent } from './modals';
import { TaskNotesComponent } from './modals';
import { ActivateUserComponent } from './modals';
import { NotificationGroupsComponent } from './modals';
import { NotificationRecipientsComponent } from './modals';
import { SurveyQuestionsModalComponent } from './modals';
import { CalendarModalComponent } from './modals';
import { SurveySubmissionModalComponent } from './modals';

import { UsersService } from './services';
import { GroupsCommitteesService } from './services';
import { CampaignsService } from './services';
import { TasksService } from './services';
import { MeetingsService } from './services';
import { NotificationsService } from './services';
import { SurveysService } from './services';
import { CalendarService } from './services';

// Application wide providers
const APP_PROVIDERS = [
    AppState,
    GlobalState
];

export type StoreType = {
    state: InternalStateType,
    restoreInputValues: () => void,
    disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
    bootstrap: [App],
    declarations: [
        App,
        ConfirmComponent,
        ConfirmMemberComponent,
        SurveyErrorActivateComponent,
        GroupMembersComponent,
        TaskPerformersComponent,
        TaskGroupsComponent,
        TaskNotesComponent,
        ActivateUserComponent,
        NotificationGroupsComponent,
        NotificationRecipientsComponent,
        SurveyQuestionsModalComponent,
        CalendarModalComponent,
        SurveySubmissionModalComponent
    ],
    imports: [ // import Angular's modules
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgaModule.forRoot(),
        NgbModule.forRoot(),
        PagesModule,
        routing,
        SlimLoadingBarModule.forRoot(),
        ToastrModule.forRoot({ 
            timeOut: 3500,
        }),
        BootstrapModalModule,
        NgUploaderModule,
        MultiselectDropdownModule,
        AppTranslationModule,
        DataTableModule,
        DateTimePickerModule,
        AmChartsModule
    ],
    entryComponents: [
        ConfirmComponent,
        ConfirmMemberComponent,
        SurveyErrorActivateComponent,
        GroupMembersComponent,
        TaskPerformersComponent,
        TaskGroupsComponent,
        TaskNotesComponent,
        ActivateUserComponent,
        NotificationGroupsComponent,
        NotificationRecipientsComponent,
        SurveyQuestionsModalComponent,
        CalendarModalComponent,
        SurveySubmissionModalComponent
    ],
    providers: [ // expose our Services and Providers into Angular's dependency injection
        APP_PROVIDERS,
        UsersService,
        GroupsCommitteesService,
        CampaignsService,
        TasksService,
        MeetingsService,
        NotificationsService,
        SurveysService,
        CalendarService
    ]
})

export class AppModule {
    constructor(public appState: AppState) {}
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/app.module.ts